import { HttpClient } from '@angular/common/http';
import {
    TRANSLOCO_LOADER,
    Translation,
    TranslocoLoader,
    TRANSLOCO_CONFIG,
    translocoConfig,
    TranslocoMissingHandler,
    TranslocoConfig,
    TRANSLOCO_MISSING_HANDLER,
    HashMap,
} from '@ngneat/transloco';
import { Injectable, NgModule } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ITTPResponse } from './ttp-response.model';
import { catchError } from 'rxjs/operators';
import { isProdFromClientUrl } from '../utils/utils';
import { ApiService } from '../services/api.service';
import { AppConstants, AppSettings } from '../../app.settings';
import { appConstantsFactory } from '../../app.module';
import { AuthData } from '@tesla/ng-auth';

@Injectable({ providedIn: 'root' })

export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(
        private http: HttpClient,
        private apiService: ApiService,
        private config: AppSettings,
        private authData: AuthData,
    ) {}

    public environment = this.config.SRM_API_URL;

    getTranslation(path: string): Observable<ITTPResponse | Translation> {
        // get template translation from ttp
        if (!this.authData?.getAccessToken()?.idToken) {
            return of(null);
        }
        const useProdEnv = localStorage.getItem('use-prod-env') || "false";
        if (path.includes('task-template/')) {
            const token = path.split('/');
            const fileName = token.pop();
            token.shift();
            const resourceName = token.join('/');
            if (resourceName && resourceName != 'null') {
                return this.apiService
                    .get(
                        `${this.config.SRM_API_URL}Translation?resourceName=${resourceName}&fileName=${fileName}.json`,
                    )
                    .pipe(catchError((error) => of(null)));
            } else {
                return of(null);
            }
        } else if (path.includes('task/')) {
            // get other task related translation from ttp
            const [resourceName, fileName] = path.split('/');
            return this.apiService
                .get(`${this.config.SRM_API_URL}Translation?resourceName=${resourceName}&fileName=${fileName}.json`)
                .pipe(catchError((error) => of(null)));
            } else if (path.includes('profile/')) {
                const [resourceName, language] = path.split('/');
            if(language) {
                return this.http.get<Translation>(`/assets/i18n/profile/${language}.json`)
            } else {
                return of(null)
            }
        } else {
            if(path) {
                return this.apiService
                .get(`${this.config.BaseUrl}Profile/Translation?resourceName=app&fileName=${path}.json&useProdEnv=${useProdEnv}`)
                .pipe(catchError((error) => {return this.http.get<Translation>(`/assets/i18n/profile/${path}.json`)}));
            } else {
                return this.http.get<Translation>(`/assets/i18n/profile/en-US.json`)
            }
        }
    }
}

export class CustomHandler implements TranslocoMissingHandler {
    handle(key: string, params: HashMap, config: TranslocoConfig): string {
        return '';
    }
}
const appConstants = appConstantsFactory();
const prodMode = isProdFromClientUrl(appConstants.SRM_API_URL);

@NgModule({
    providers: [
        {
            provide: TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs: [
                    'zh-CN',
                    'cs-CZ',
                    'da-DK',
                    'en-US',
                    'fi-FI',
                    'fr-FR',
                    'de-DE',
                    'zh-HK',
                    'hu-HU',
                    'is-IS',
                    'it-IT',
                    'ja-JP',
                    'ko-KR',
                    'no-NO',
                    'pl-PL',
                    'es-ES',
                    'es-MX',
                    'sv-SE',
                    'tr-TR',
                    'zh-TW'
                ],
                fallbackLang: ['en-US'],
                defaultLang: 'en-US',
                // Remove this option if your application doesn't support changing language in runtime.
                reRenderOnLangChange: true,
                prodMode,
            }),
        },
        { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
        {
            provide: TRANSLOCO_MISSING_HANDLER,
            useClass: CustomHandler,
        },
    ],
})
export class TranslocoRootModule {}
